<template>
	<lcsj-dialog v-model="showDetailVisible" title="申购单接收" :append-to-body="true" width="90%" @close="closeDialog()" cancel-text="取消" confirm-text="确认接收" :confirm-loading="isSubmitting" @confirm="handleSubmitClick"> <div class="main_bg">
			<div class="item_info border_Green">
				<div class="item_title">
					<div class="title">接收商品信息</div>
					<div class="btnDiv"></div>
				</div>
				<el-table class="lcsj-data-table" :cell-class-name="$moneyCellClass" :data="productTableData" style="width: 100%" border :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }">
					<el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
					<el-table-column prop="typeName" label="类型" width="140"></el-table-column>
					<el-table-column prop="productName" label="系列" width="160"></el-table-column>
					<el-table-column prop="specification" label="商品名称" width="160"></el-table-column>
					<el-table-column prop="productBrand" label="商品品牌" width="160"></el-table-column>
					<el-table-column prop="quantity" label="申购数量" width="90"></el-table-column>
					<el-table-column prop="actualQty" label="实际数量" width="140">
						<template #default="scope">
							<el-input-number v-model.number="scope.row.actualQty" type="number" :min="0" size="mini" style="width: 100%" :max="scope.row.quantity" :step="1" :precision="0"></el-input-number>
						</template>
					</el-table-column>
					<el-table-column prop="unit" label="单位" width="70"></el-table-column>
					<el-table-column prop="kdNo" label="快递单号" width="220"></el-table-column>
					<el-table-column prop="remark" label="备注" width="220"></el-table-column>
				</el-table>
			</div>
		</div>
		
	</lcsj-dialog>
</template>

<script>
import { GetStoreSubscriptionDetail, ReceiveStoreSubScription } from "@/api/productApi.js";
export default {
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			showDetailVisible: false,
			loading: false,
			subscriptionInfo: {},
			productTableData: []
		};
	},
	created() {},
	mounted() {},
	methods: {
		// 展示接收弹窗
		showReceive(keyId) {
			this.subscriptionInfo = {};
			this.productTableData = [];
			GetStoreSubscriptionDetail({
				keyId: keyId
			}).then((res) => {
				if (res.code == 1) {
					this.subscriptionInfo = res.data;
					this.productTableData = [];
					if (res.data.dtls != null && res.data.dtls.length > 0) {
						var index = 1;
						res.data.dtls.forEach((item) => {
							this.productTableData.push({
								rowNumber: index++,
								typeName: item.productTypeInfo.typeName,
								productName: item.productTypeInfo.productName,
								specification: item.productTypeInfo.specification,
								quantity: item.quantity,
								unit: item.productTypeInfo.unit,
								remark: item.remark,
								keyId: item.keyId,
								kdNo: item.kdNo,
								productBrand: item.productBrand,
							//默认实际数量等于申购数量，可调小
							actualQty: item.quantity
							});
						});
					}
				} else {
					this.$message.error(res.msg);
				}
			});
			this.showDetailVisible = true;
		},
		// 关闭弹窗
		closeDialog() {
			this.subscriptionInfo = {};
			this.showDetailVisible = false;
		},
		// 接收提交
		handleSubmitClick() {
			var isPass = true;
			var dtls = [];
			// 校验实际数量
			this.productTableData.forEach((item) => {
				if (item.actualQty > item.quantity) {
					this.$message.error("实际数量不能大于申购数量");
					isPass = false;
					return;
				}
				if (item.actualQty < 0) {
					this.$message.error("实际数量不能小于0");
					isPass = false;
					return;
				}
				dtls.push({
					keyId: item.keyId,
					actualQty: item.actualQty,
					//入库数量以实际接收数量为准
					inboundQty: item.actualQty
				});
			});
			if (!isPass) {
				return;
			}
			if (dtls.length == 0) {
				this.$message.error("未获取到接收明细信息");
				return;
			}
			//至少有一条实际接收
			var hasReceive = this.productTableData.some((item) => item.actualQty > 0);
			if (!hasReceive) {
				this.$message.error("请填写接收数量，接收数量不能全部为0");
				return;
			}
			this.$confirm("确认接收吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.loading = true;
				ReceiveStoreSubScription({
					keyId: this.subscriptionInfo.keyId,
					dtls: dtls
				})
					.then((res) => {
						if (res.code == 1) {
							this.$message.success("接收成功");
							this.closeDialog();
							this.$emit("success");
						} else {
							this.$message.error(res.msg);
						}
					})
					.finally(() => {
						this.loading = false;
					});
			});
		}
	}
};
</script>

<style scoped>
.main_bg {
	padding: 10px;
	margin-top: -15px;
}

.item_info {
	border-left: 5px solid var(--app-primary-hover);
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border: 2px solid var(--app-border);
}

.border_Green {
	border-left: 5px solid var(--app-success);
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;
}

.title {
	display: inline-block;
	unicode-bidi: isolate;
}

.btnDiv {
	display: block;
	unicode-bidi: isolate;
	word-break: break-all;
}
</style>
